<div class="slide-toggle">
  <input type="checkbox" [checked]="isChecked" (change)="onChange($event)" [id]="id" />
  <label class="slide-toggle-switch" [for]="id"></label>
  <label class="slide-toggle-label"><ng-content></ng-content></label>
</div>
